export enum ContrastMode {
  dark = 'dark',
  light = 'light',
}
